import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoardSnowTop = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 504,
	height: 41,
	fill: "none",
	viewBox: "0 0 504 41",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M.5 13.5s9.73.68 22.73 4.41c13.01 3.73 107.34 1.28 179.1 2.53 34.18.6 53.36 0 87.55 0 28.52 0 44.52-.27 73.04 0 46.78.45 75.38 13.19 119.7 3.05 8.47-1.93 20.07-3.6 21.13-5.94 1.06-2.34-.72-8.48-16.34-14.3-19.53-7.3-42.65-.55-53.4 3.23-10.77 3.78-42.66 4.05-55.41 0s-30.69 0-43.84 4.05c-13.16 4.05-30.7 0-36.27-4.05-5.58-4.05-25.91 0-37.87 4.05-9.56 3.24-26.57 1.35-33.88 0-10.76-1.35-36.66-4.05-54.2-4.05-21.92 0-39.46 4.05-54.2 0-11.8-3.24-26.98 1.35-33.09 4.05-5.84 0-19.29-.8-26.3-4.05C51.93 3.24 4.09 12.15.5 13.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M73.5 25.3c-7.79 1.88-14 0-23.5 0s-10.48 3.3-20-1.8C24.32 20.46 16.5 14 16.5 14l197.34 6.48L289.5 18H353L460.52 6l19.25 8.85c.97 3.49-.65 12.63-14.9 21.32-17.8 10.86-38.87.8-48.68-4.83-9.8-5.63-38.87-6.03-50.5 0-11.62 6.04-27.97 0-39.96-6.03-11.99-6.04-27.97 0-33.06 6.03-5.08 6.04-23.61 0-34.51-6.03-8.72-4.83-24.22-2.01-30.88 0-9.81 2-33.42 6.03-49.41 6.03-19.98 0-35.97-6.03-49.4 0-10.76 4.83-24.6-2.01-30.16-6.03-5.33 0-17.31-1.81-24.81 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#C3D0E6",
			d: "M131.92 17.43c-1.61 0-3.25-.04-4.92-.13l4.92.13c13.91.01 26.16-2.91 40.5-1.95 15.8 1.05 7.6-2.76 23.33-1.02 4.75.52 7.4 1.2 8.89 1.75.97.37.71 1.13-.33 1.17l-16.13.62-18.3-.7-17.02.7-20.94-.57Zm300.49 2.05c-10.84-.73-20.02-1.9-29.8-2.84-1.77-.17-2.15 2.12-.43 2.57l10.47 2.73c.14.04.28.06.43.05l16.48-.68c.21 0 .43.03.63.12 1.36.57 6.94 2.88 10.81 4.07 3.11.96 7.74 2 9.39 2.37.39.08.8 0 1.13-.22l11.04-7.45c1.44-.97.3-3.2-1.33-2.61l-9.79 3.55c-.29.1-.6.12-.9.06-1.27-.23-5.62-.89-18.13-1.72Z"
		})
	]
});
export default SvgBoardSnowTop;
